import type {
  EnrollmentReportItem,
  FinancialSummaryReportItem,
  MonitoringReportItem,
  PaginatedReportResponse,
  ReportEndpointType,
  ReportExportParams,
  ReportsQueryParams,
  SaeSummaryReportItem,
  SitePerformanceReportItem,
} from "@/types/reports.type";
import type { IReportsRepository } from "@/repositories/ReportsRepository";

export interface IReportsUseCase {
  getEnrollmentReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<EnrollmentReportItem>>;
  getSitePerformanceReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<SitePerformanceReportItem>>;
  getMonitoringReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<MonitoringReportItem>>;
  getSaeSummaryReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<SaeSummaryReportItem>>;
  getFinancialSummaryReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<FinancialSummaryReportItem>>;
  exportReport(
    reportType: ReportEndpointType,
    params: ReportExportParams,
  ): Promise<Blob>;
}

export class ReportsUseCase implements IReportsUseCase {
  constructor(private readonly reportsRepository: IReportsRepository) {}

  async getEnrollmentReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<EnrollmentReportItem>> {
    return this.reportsRepository.getEnrollmentReport(params);
  }

  async getSitePerformanceReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<SitePerformanceReportItem>> {
    return this.reportsRepository.getSitePerformanceReport(params);
  }

  async getMonitoringReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<MonitoringReportItem>> {
    return this.reportsRepository.getMonitoringReport(params);
  }

  async getSaeSummaryReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<SaeSummaryReportItem>> {
    return this.reportsRepository.getSaeSummaryReport(params);
  }

  async getFinancialSummaryReport(
    params: ReportsQueryParams,
  ): Promise<PaginatedReportResponse<FinancialSummaryReportItem>> {
    return this.reportsRepository.getFinancialSummaryReport(params);
  }

  async exportReport(
    reportType: ReportEndpointType,
    params: ReportExportParams,
  ): Promise<Blob> {
    return this.reportsRepository.exportReport(reportType, params);
  }
}
